export { default as ChipGroup } from './ChipGroup'
export type { ChipGroupProps } from './types'
export { ChipGroupVariant } from './types'
